module.exports = __webpack_public_path__ + "static/media/smallLogo.be82a68b.png";